import React, { useEffect, useState } from 'react';
import { makeStyles } from "@mui/styles";
import FlagstoneTheme from '../../../Config/flagstoneTheme';
import { dataService } from '../../../Services/data/data.service'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { systemParameters } from '../../../Config/constants';


export const TransportDashboardPage = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const [transportDashboardUrl, setTransportDashboardUrl] = useState("");

    useEffect(() => {
        if (props.general.systemParameters.Results && props.general.systemParameters.Results !== null && props.general.systemParameters.Results !== undefined && props.general.systemParameters.Results.length > 0) {
            console.log(props.general.systemParameters)
            let transportDashboardUrl = props.general.systemParameters.Results.find(x => x.Id === systemParameters.TransportDashboardUrl);
            if (transportDashboardUrl !== null && transportDashboardUrl !== undefined) {
                setTransportDashboardUrl(transportDashboardUrl.Value);
            }
        }
    }, [props.general.systemParameters.Results])

    return (
        <div className={classes.container}>
            <iframe
                src={transportDashboardUrl}
                width="100%"
                height="100%"
                frameBorder="0"
                title="Transport Dashboard"
            ></iframe>
        </div>
    )
}

const useStyles = makeStyles({
    container: {
        width: '100%',
        height: 'calc(100vh - 50px)',
        position: "relative",

    },
});

function mapStateToProps(state) {
    return {
        workstation: state.workstation,
        general: state.general,
        user: state.user
    }
}

export default connect(mapStateToProps)(TransportDashboardPage)